import React from 'react'

import GlobalWrapper from 'components/global-wrapper'
import Hero from 'components/hero'
import Section from 'components/section'
import JailPopulation from 'components/jail_population'
import Incidents from 'components/incidents'
import Arrests from 'components/arrests'
import Filings from 'components/filings'
import Caseloads from 'components/caseload'
import PrisonParole from 'components/prisonParole'
import SmallMultiples from 'components/small_multiple'


import Footer from 'components/footer'
import styled from 'styled-components'


const Container = styled.div`
        alignItems:'center',
        justifyContent:'center',
        flex:1,
        }`

export default class App extends React.Component {
  render() {
    return (
      <GlobalWrapper>
        <Hero />
        <Section id={'overall-trends'}>
          <SmallMultiples></SmallMultiples>
        </Section>
        <Section id={'incidents'}>
          <Incidents/>
        </Section>
        <Section id={'arrests'}>
          <Arrests/>
        </Section>
        <Section id={'jail-population'}>
          <JailPopulation/>
        </Section>
        <Section id={'filings'}>
          <Filings/>
        </Section>
        <Section id={'caseload'}>
          <Caseloads/>
        </Section>
        <Section id={'prison-parole'}>
          <PrisonParole/>
        </Section>
        <Footer />
      </GlobalWrapper>
    )
  }
}
